import {selection} from "d3-selection";

var Selection = selection.prototype.constructor;

export default function() {
  return new Selection(this._groups, this._parents);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/src/transition/selection.js
// module id = 192
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14